import {apiWithToken} from '../../systems/api/index';
import {API_URL} from './../../systems/globalContant';

export default {
    getServices: (filters = {})=> apiWithToken.get(API_URL.GET_LIST_SERVICES_API,  {params: filters}, {loading: false})
}
